import { StatusScreenContent } from '~domains/partner-application/shared/ui/status-screen-content';

import { useWaitUserPermissions } from '~platform/auth';

import { Screen } from '~shared/ui/screen';

import { Hourglass as HourglassIllustration } from '@breezeventures/ui-kit/next/illustrations/medium/hourglass';

import { PartnerApplicationMenuHeader } from '../../partner-application-menu-header';

export const SignedScreen = () => {
  useWaitUserPermissions();

  return (
    <Screen header={<PartnerApplicationMenuHeader />}>
      <StatusScreenContent
        icon={<HourglassIllustration alt="" />}
        title={<>Please wait a&nbsp;moment…</>}
        description={
          <>
            We&#39;re creating your personal account. This usually takes
            a&nbsp;few minutes.
          </>
        }
        action={{
          label: 'Refresh',
          onClick: () => {
            window.location.reload();
          },
        }}
      />
    </Screen>
  );
};
